import ImagePerson from "@/components/functionals/ImagePerson.vue";
import CellDateTime from "@/components/functionals/DatetimeFormatter.vue";
import { formatterMoney } from "@/utils";
import InteractionTypeTagFormatter from "@/components/functionals/InteractionTypeTagFormatter.vue";

export default [
  {
    prop: "ClientCode",
    name: "ClientCode",
    label: "Código de Cliente",
    width: 200,
    align: "center",
    sortable: true
  },
  {
    prop: "Nombre",
    name: "Nombre",
    label: "Nombre del Cliente",
    formatter: ImagePerson,
    width: 300,
    sortable: true
  },
  {
    prop: "StatusLabel",
    label: "Contrato Navision",
    align: "center",
    width: 150,
    formatter: InteractionTypeTagFormatter
  },
  {
    prop: "NavixiEstatus",
    label: "Estatus Navixi",
    align: "center",
    width: 150,
    formatter: InteractionTypeTagFormatter
  },

  {
    prop: "SalesPersonName",
    label: "Vendedor",
    width: 200,
    formatter: ImagePerson,
    attrs: {
      imgKey: "SalesPersonImage"
    }
  },
  {
    label: "Servicio al Cliente",
    prop: "CustomerServiceName",
    width: 250,
    formatter: ImagePerson,
    sortable: true,
    attrs: {
      imgKey: "CustomerServiceImage"
    }
  },
  {
    label: "Agente de Cobro",
    prop: "accountExecName",
    width: 250,
    formatter: ImagePerson,
    sortable: true,
    attrs: {
      imgKey: "accountPhotoExec"
    }
  },
  {
    prop: "NoContrato",
    label: "No. Contrato",
    minWidth: 130,
    sortable: true
  },
  {
    prop: "Amount",
    label: "Monto",
    minWidth: 100,
    sortable: true,
    align: "center",
    formatter: (row) => formatterMoney(row.Amount)
  },
  {
    prop: "Qty",
    label: "Cantidad Navision",
    minWidth: 125,
    sortable: true,
    align: "center"
  },
  {
    prop: "QTY_Navixi",
    label: "Cantidad Navixi",
    minWidth: 125,
    sortable: true,
    align: "center"
  },
  {
    prop: "TipoProcesoLabel",
    label: "Tipo de Proceso",
    minWidth: 180,
    sortable: true
  },
  {
    prop: "FechaInicio",
    label: "Fecha de Inicio",
    minWidth: 180,
    sortable: true,
    formatter: CellDateTime
  },
  {
    prop: "FechaVence",
    label: "Fecha Vence",
    width: 180,
    sortable: true,
    formatter: CellDateTime
  }
  /*
  {
    prop: "DiaFacturacion",
    label: "Dia de Facturación",
    width: 180,
    sortable: true
  },
  */
  /*
  {
    prop: "UltFechaFacturacion",
    label: "Última Fecha de Facturación",
    width: 240,
    sortable: true,
    formatter: CellDateTime
  },
  {
    prop: "ProxFechaFacturacion",
    label: "Próxima Fecha de Facturación",
    width: 240,
    sortable: true,
    formatter: CellDateTime
  },
  {
    prop: "PorcCalcMora",
    label: "Porcentaje de Mora",
    width: 180,
    sortable: true
  },
  {
    prop: "StatusLabel",
    label: "Status",
    width: 100,
    sortable: true
  },
  */
  /*
  {
    prop: "FixetAsset",
    label: "Activos Fijos",
    minWidth: 140,
    sortable: true,
    align: "center"
  }
  */
];
